import HttpMethod from '../../services/httpMethods'
import { ApiResponse } from '../../services/types';
import { makeRequest } from '../../services/restcall';



export async function postSendEmailSolicitudBusinessProjectAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/messages/email/solicitud/projects',value)
}
